package tools

import androidx.compose.ui.graphics.ImageBitmap
import androidx.compose.ui.graphics.asSkiaBitmap
import io.ktor.http.*
import kotlinx.coroutines.flow.Flow
import org.jetbrains.skia.EncodedImageFormat
import org.jetbrains.skia.Image
import tk.mallumo.utils.GenId
import kotlin.time.Duration


class ImageFile(
    name: String,
    bytes: ByteArray,
    type: String,
    val image: ImageBitmap
) : VirtualFile(name, type, bytes)

open class VirtualFile(
    var name: String,
    var mime: String,
    val bytes: ByteArray,
    val id: Long = GenId.get()
) {
    companion object;
}

data class FilePickerUploadState(
    var all: Int,
    var success: Int = 0,
    var failure: Int = 0,
    var tooLargeFiles: Int = 0,
    var invalidCustomVideoFormat: Int = 0
)

interface FilePickerUploadParams {
    fun buildUrl(): String
    fun buildHeaders(
        name: String,
        mime: String
    ): Array<Pair<String, String>>
}

@Suppress("NOTHING_TO_INLINE")
inline fun HttpStatusCode.error(msg: String = ""): Nothing = throw StatusCodeErr(this, msg)

class StatusCodeErr(val code: HttpStatusCode, extras: String = "") :
    Exception("${code.value} ${code.description} $extras")

@Suppress("EXPECT_ACTUAL_CLASSIFIERS_ARE_IN_BETA_WARNING")
expect object FilePicker {

    suspend fun uploadFromPicker(
        contentTypes: List<String>,
        pickerTimeout: Duration,
        params: FilePickerUploadParams,
        multiple: Boolean = true,
        onNewFile: suspend (json: String) -> Unit = {}
    ): Flow<FilePickerUploadState>

    suspend fun single(
        contentType: String = "*/*",
        onStart: suspend (name: String) -> Unit = {}
    ): VirtualFile?

    suspend fun uploadBinary(data: ByteArray, mime: String, name: String)

}

suspend fun FilePicker.uploadImage(imageBitmap: ImageBitmap, name: String = "export") {
    val data = Image.makeFromBitmap(imageBitmap.asSkiaBitmap())
        .encodeToData(EncodedImageFormat.PNG)
        ?.bytes
        ?: return

    uploadBinary(data, "image/png", "${name}.png")
}

suspend fun FilePicker.uploadZip(data: ByteArray, name: String = "export") {
    uploadBinary(data, "application/zip", "${name}.zip")
}
